module.exports = __webpack_public_path__ + "img/23.7617b409.webp";